<template>
  <controller>
    <page-header title="Políticas">
      <template #side>
        <a
          href="#"
          class="btn btn-primary"
          v-if="!novo"
          @click.prevent="newPolitica"
        >
          <span>Nova Política</span>
        </a>
      </template>
    </page-header>

    <main>
      <header class="searchHeader">
        <div class="frame nano fixed">
          <input-control
            search
            preventSearchButton
            v-model="query"
            placeholder="Buscar..."
          />
        </div>
      </header>

      <section>
        <politicas
          ref="politicas"
          @politica-salva="voltarBotao"
          @politica-cancelada="voltarBotao"
        />
      </section>
    </main>
  </controller>
</template>

<script>
import Politicas from '@/components/financeiro/negocieja/politicas/template/Politicas.vue'

export default {
  components: { Politicas },
  data () {
    return {
      query: '',
      novo: false
    }
  },
  methods: {
    newPolitica () {
      // chama o método interno do componente-lista
      this.$refs.politicas.novaPolitica()
      this.novo = true
    },
    voltarBotao () {
      this.novo = false
    }
  }
}
</script>

<style lang="scss" scoped>
.searchHeader {
  width: 100%;
  padding: $hmg_mid;
  border-bottom: $border-component;
}
</style>